var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_c('v-row',_vm._l((_vm.proposals),function(proposal){return _c('v-col',{key:proposal.proposalId,attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg}},[_c('ProposalGridCard',{attrs:{"proposal":proposal}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }